// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"2d8bba67","508":"da6c3be4","776":"3c049a22"}[chunkId] + ".chunk.js";
};